import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { InitializationWrapper } from '../../components/index'
import { ContainerJourneyHistoryHeader } from './components/Molecules/ContainerJourneyHistoryHeader'
import { ContainerJourneyHistoryTable } from './components/Molecules/ContainerJourneyHistoryTable'
import {
  ContainerJourneyHistoryViewStore,
  FetchOpsAdditionalDataFn,
} from './stores/ContainerJourneyHistoryViewStore'

export interface ContainerJourneyHistoryPageProps {
  fetchOpsAdditionalData?: FetchOpsAdditionalDataFn
}

export const ContainerJourneyHistoryPage = observer(
  ({ fetchOpsAdditionalData }: ContainerJourneyHistoryPageProps) => {
    const theme = useMinimalsTheme()
    const { id, turnoverId } = useParams()
    const { containerItemStore } = usePlanningStore()

    const containerHistoryViewStore = useMemo(
      () => new ContainerJourneyHistoryViewStore(containerItemStore, fetchOpsAdditionalData),
      [containerItemStore, fetchOpsAdditionalData],
    )

    const containerId = id ? parseInt(id) : undefined

    const { loading } = useAsyncFetch(async () => {
      if (containerId) {
        await containerHistoryViewStore.fetch(containerId, turnoverId)
      }
    }, [containerHistoryViewStore, containerId, turnoverId])

    return (
      <InitializationWrapper isInitializing={loading}>
        <Box
          sx={{
            minHeight: '100%',
            bgcolor: theme.palette.grey[100],
          }}
        >
          <ContainerJourneyHistoryHeader
            containerId={containerId}
            containerNumber={containerHistoryViewStore.container?.data.number}
            inboundVisitName={
              containerHistoryViewStore.containerHistoryDto?.InboundCarrierVisit?.CarrierName
            }
            outboundVisitName={
              containerHistoryViewStore.containerHistoryDto?.OutboundCarrierVisit?.CarrierName
            }
          />
          <Box padding={theme.customSpacing.m}>
            <ContainerJourneyHistoryTable
              containerEvents={containerHistoryViewStore.sortedEvents}
            />
          </Box>
        </Box>
      </InitializationWrapper>
    )
  },
)
